export default __webpack_public_path__ + "static/media/1.b2048034.png";